module.exports = __webpack_public_path__ + "0f165298ba859d1a0c03e0c0dd27faee.pdf";